<template>
  <div class="container-fluid">
    <div class="McqVideoPostElementAdaptiveGameDropdown">
      <div class="row vertical-align padding-bottom-15px">
        <div class="container">
          <div class="col-md-4 col-lg-4 padding-6px-0px">
            <div class="row vertical-align">
              <div class="col-md-2 col-lg-2 font-weight-bold font-color-blue">
                {{currOptionObjValue.OptionNo}}.
              </div>
              <div class="col-md-10 col-lg-10 text-align-left padding-left-0px">{{currOptionObjValue.OptionText}}</div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group col-md-11 col-md-offset-1 col-lg-11 col-lg-offset-1 margin-bottom-0px">
              <select class="form-control" v-model="firstDDObjValue" :disabled="currActivatedRow < currOptionIndex">
                <option value=-1 disabled>Select</option>
                <option v-for="currVideoObj in getVideoList" :key="currVideoObj.ElementId" :value="currVideoObj">{{currVideoObj.Title}}</option>
              </select>
            </div>  
          </div>
          <div class="col-md-3 col-md-offset-1 col-lg-3 col-lg-offset-1 padding-right-0px">
            <div class="form-group margin-bottom-0px">
              <select class="form-control" v-model="secondDDObjValue" :disabled="currActivatedRow < currOptionIndex || disableSecondDD">
                <option value=-1 disabled>Select</option>
                <option v-for="currObj in getCombinedMcqAndPostElemStepsList" :key="currObj.ElementId" :value="currObj" v-if="currObj.ElementId !== parentMcqObjValue.ElementId">{{currObj.Title}}</option>
              </select>
            </div>  
          </div>
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
// import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import map from 'lodash/map'
import filter from 'lodash/filter'
import flatten from 'lodash/flatten'
export default {
  props: ['overallList', 'currSelectedMcqObj', 'currOptionObj', 'currOptionIndex', 'currActivatedRow', 'gameLevelObj'],
  created: function () {
    this.setIdToEachDD()
    this.generateCombinedList()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      firstDDObj: -1,
      secondDDObj: -1,
      firstDDId: '',
      secondDDId: '',
      combinedMcqAndPostElemList: [],
      disableSecondDD: false
    }
  },
  name: 'McqVideoPostElementAdaptiveGameDropdown',
  methods: {
    setIdToEachDD: function () {
      if (this.firstDDId === '') {
        this.firstDDId = this.getRandomStringId()
        console.log('created: First DD unique id is:' + this.firstDDId)
      }
      if (this.secondDDId === '') {
        this.secondDDId = this.getRandomStringId()
        console.log('created: Second DD unique id is:' + this.secondDDId)
      }
    },
    getRandomStringId: function () {
      return 'id_' + Math.random().toString(36).substr(2, 16)
    },
    disableSecondDDOption: function () {
      const mappedAssociations = map(this.gameLevelObjValue, 'Associations')
      const videoAssociations = filter(flatten(mappedAssociations), { Type: 'Video' })
      const videoIds = map(videoAssociations, 'ObjectId')
      this.disableSecondDD = videoIds.indexOf(this.firstDDObj.ElementId) > -1
    },
    generateCombinedList: function () {
      this.combinedMcqAndPostElemList = []
      for (var i = 0; i < this.getMcqList.length; i++) {
        this.combinedMcqAndPostElemList.push(this.getMcqList[i])
      }
      for (var j = 0; j < this.getPostElementList.length; j++) {
        this.combinedMcqAndPostElemList.push(this.getPostElementList[j])
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    gameLevelObjValue: {
      get: function () {
        return this.gameLevelObj
      }
    },
    currActivatedRowValue: {
      get: function () {
        return this.currActivatedRow
      }
    },
    getCurrentOptionIndexValue: {
      get: function () {
        return this.currOptionIndex
      }
    },
    secondDDObjValue: {
      get: function () {
        return this.secondDDObj
      },
      set: function (newValue) {
        this.secondDDObj = newValue
        if (this.disableSecondDD) {
          if (this.firstDDObjValue !== -1) {
            var objToPass = {
              currOptionObj: this.currOptionObjValue,
              currOptionIndex: this.getCurrentOptionIndexValue,
              firstDDId: this.firstDDId,
              firstDDValue: this.firstDDObjValue,
              secondDDId: this.secondDDId,
              secondDDValue: -1
            }
            this.$emit('currOptionObj', objToPass)
          }
        } else if (this.firstDDObjValue !== -1 && this.secondDDObj !== -1) {
          objToPass = {
            currOptionObj: this.currOptionObjValue,
            currOptionIndex: this.getCurrentOptionIndexValue,
            firstDDId: this.firstDDId,
            firstDDValue: this.firstDDObjValue,
            secondDDId: this.secondDDId,
            secondDDValue: newValue
          }
          this.$emit('currOptionObj', objToPass)
        } else {
          console.log('*** Second DD Failed ***')
          // console.log(this.firstDDObjValue)
          // console.log(this.secondDDObj)
          // console.log(!this.disableSecondDD)
        }
      }
    },
    firstDDObjValue: {
      get: function () {
        return this.firstDDObj
      },
      set: function (newValue) {
        this.firstDDObj = newValue
        this.disableSecondDDOption()
        if (this.disableSecondDD) {
          if (this.firstDDObjValue !== -1) {
            var objToPass = {
              currOptionObj: this.currOptionObjValue,
              currOptionIndex: this.getCurrentOptionIndexValue,
              firstDDId: this.firstDDId,
              firstDDValue: this.firstDDObjValue,
              secondDDId: this.secondDDId,
              secondDDValue: -1
            }
            this.$emit('currOptionObj', objToPass)
          }
        } else if (this.firstDDObjValue !== -1 && this.secondDDObj !== -1) {
          objToPass = {
            currOptionObj: this.currOptionObjValue,
            currOptionIndex: this.getCurrentOptionIndexValue,
            firstDDId: this.firstDDId,
            firstDDValue: this.firstDDObjValue,
            secondDDId: this.secondDDId,
            secondDDValue: this.secondDDObjValue
          }
          this.$emit('currOptionObj', objToPass)
        } else {
          console.log('*** First DD Failed ***')
          // console.log(this.firstDDObjValue)
          // console.log(this.secondDDObj)
          // console.log(!this.disableSecondDD)
        }
      }
    },
    getCombinedMcqAndPostElemStepsList: {
      get: function () {
        return this.combinedMcqAndPostElemList
      }
    },
    currOptionObjValue: {
      get: function () {
        return this.currOptionObj
      }
    },
    parentMcqObjValue: {
      get: function () {
        return this.currSelectedMcqObj
      }
    },
    getOverallList: {
      get: function () {
        return this.overallList
      }
    },
    getMcqList: {
      get: function () {
        return this.getOverallList.currentMcqList
      }
    },
    getVideoList: {
      get: function () {
        return this.getOverallList.currentVideoList
      }
    },
    getPostElementList: {
      get: function () {
        return this.getOverallList.currentPostList
      }
    },
    currSelectedMcqObjValue: {
      get: function () {
        return this.currSelectedMcqObj
      }
    }
  },
  watch: {
    getOverallList: function (newValue, oldValue) {
      console.log('getOverallList: ' + newValue.length + ' ::: ' + oldValue.length)
      this.generateCombinedList()
    }
  }
}
</script> 
<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-14px {
    font-size: 14px;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.margin-left-10px {
    margin-left: 10px;
}
.padding-2px {
    padding:2px;
}
.padding-left-0perc {
    padding-left: 0%;
}
.padding-right-0px {
  padding-right:0px
}
.padding-6px-0px {
  padding:6px 0px;
}
.font-weight-bold {
  font-weight:bold;
}
.font-size-21px {
  font-size:21px;
}
.padding-bottom-15px {
  padding-bottom:15px;
}
.font-color-blue {
  color:#34495e
}
</style>



// WEBPACK FOOTER //
// src/components/adaptive_game/McqVideoPostElementAdaptiveGameDropdown.vue